module.exports = __webpack_public_path__ + "img/knowUsLeftBg.920ec7b1.png";